module.exports = __webpack_public_path__ + "img/PPT版_00.286db317.png";